// Polyfills
import 'whatwg-fetch';
import 'mdn-polyfills/CustomEvent';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/Element.prototype.matches';
import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/NodeList.prototype.forEach'; // See `babel.config.js`
import 'svg-classlist-polyfill';
import 'focus-visible';

// Fonts
import './_fonts';

// Styles
import '../css/_main-new.scss';

// New components
import '../../components/expandable/expandable';
import '../../components/icon/icon';
import '../../components/logo/logo';
import '../../components/status/status';
import '../../components/header/header';
import '../../components/sidebar/sidebar';
import '../../components/teaser/teaser';
import '../../components/footer/footer';
import '../../components/form/form';
import '../../components/detail/detail';
import '../../components/listing/listing';
import '../../components/breadcrumb/breadcrumb';
import '../../components/tabs/tabs';
import '../../components/wizard/wizard';
import '../../components/notification/notification';
import '../../components/search/search';
import '../../components/table/table';
import '../../components/documents/documents';
import '../../components/accessconfig/accessconfig';
import '../../components/tooltip/tooltip';
import '../../components/video/video';
import '../../components/partner/partner';
import '../../components/contentteaser/contentteaser';
import '../../components/languageswitch/languageswitch';

// Legacy
import '../../components/payment/payment';
import '../../components/paragraph/paragraph';
import '../../components/circle/circle';

// Page reload, used for incorrect CSRF tokens, e.g.
document.querySelectorAll('[data-init="reload"]').forEach(element => {
	element.addEventListener('click', event => {
		event.preventDefault();

		// Not using reload since we need to avoid repeating POST requests
		window.location = window.location.href;
	});
});

// Page history back
document.querySelectorAll('[data-init="back"]').forEach(element => {
	element.addEventListener('click', event => {
		event.preventDefault();

		history.back();
	});
});

// Print mode
if (window.LN && window.LN.printMode) {
	document.querySelectorAll('details').forEach(element => {
		element.open = true;
	});
}

// import * as mdc from 'material-components-web';
// console.log({ mdc });
